import React from 'react'
import { clearSupportSession } from '../utils/authSession';

const Logout = () => {
    const redirectUrl = `${process.env.REACT_APP_Auth_WEB_BASE_URL}/logout`;

    const logoutHandler = async() => {
        clearSupportSession();
        window.location.assign(redirectUrl);
    }

    logoutHandler();

    return (
        <div>Logout...</div>
    )
}

export default Logout
